import React, {Component} from 'react';
import { observer } from "mobx-react"
import {Modal,Alert,Button,ButtonToolbar} from 'react-bootstrap'
import AlertPopupStore from './AlertPopupStore'

const AlertPopup = observer(class AlertPopup extends Component {
    onHide(){
      let store = AlertPopupStore
      store.hide()
    }

    onConfirm(){
      let store = AlertPopupStore
      store.onConfirm()
    }

    renderConfirmButton(store){
      if(store.buttonTitle!==''){
        return (
          <ButtonToolbar>
            <Button onClick={this.onConfirm.bind(this)} bsStyle='primary' style={{minWidth:'80px'}}>{store.buttonTitle}</Button>
            <Button onClick={this.onHide.bind(this)} bsStyle={store.level} style={{minWidth:'80px'}}>ยกเลิก</Button>

          </ButtonToolbar>)
      }
      else{
        return (<ButtonToolbar>

          <Button onClick={this.onHide.bind(this)} bsStyle={store.level} style={{minWidth:'80px'}}>ตกลง</Button>

        </ButtonToolbar>)
      }
    }

    render(){
      let store = AlertPopupStore
      let level = store.level==='default'?null:store.level

      return (
        <Modal show={store.show} onHide={this.onHide.bind(this)} dialogClassName="alert-popup-dialog">

          <Modal.Body>

              <Alert bsStyle={level} onDismiss={this.onHide.bind(this)} style={{minHeight:'150px'}}>
                <h4>{store.title}</h4>
                <div style={{minHeight:'50px'}}>{store.message}</div>
                <div style={{float:'right'}}>
                    {this.renderConfirmButton(store)}
                </div>
              </Alert>


          </Modal.Body>
        </Modal>
      )
    }
})

export default AlertPopup



// WEBPACK FOOTER //
// ./src/component/element/AlertPopup.js